import { Component, OnInit, afterNextRender } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { Meta } from '@angular/platform-browser';

import { LOCAL_TRANSLATION_LANGUAGE } from '../../core/constants/app.constant';
import { MultilingualService } from '../../core/services/api/multilingual.service';
import { StorageService } from '../../core/services/storage.service';
import { ENVIRONMENT } from '../../../environment/environment';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit {
    protected fallbackLanguage = LOCAL_TRANSLATION_LANGUAGE.EN;
    hideLayout = false;

    constructor(
        private meta: Meta,
        private router: Router,
        private multilingualService: MultilingualService,
        private storageService: StorageService,
        private translateService: TranslateService
    ) {
        // Consolidated client-side initialization.
        // This callback does not get called from server-side in SSR.
        afterNextRender(() => {
            this.router.events
                .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
                .subscribe((event: NavigationEnd) => {
                    const pathname = new URL(event.urlAfterRedirects, window.location.origin).pathname;
                    this.hideLayout = pathname === '/mobile/player';
                });

            // Use stored language if available, otherwise fall back to default (en-US)
            // This ensures that auth-flow pages (like /verify/devices) respect the user's language preference
            const currentLanguage = this.storageService.language || this.fallbackLanguage;

            // Only set language to storage if it wasn't already set
            if (!this.storageService.language) {
                this.storageService.setLanguage(currentLanguage);
            }

            this.translateService.setFallbackLang(currentLanguage);
            this.translateService.use(currentLanguage);
            this.multilingualService.currentLanguage.next(currentLanguage);
        });
    }

    ngOnInit(): void {
        // TPOD-359 (investigation: TPOD-2110): only override the static
        // `noindex, nofollow` in production. Non-prod environments must remain
        // un-indexed; the static tag in `index.{env}.html` is the source of truth there.
        if (ENVIRONMENT.production) {
            this.meta.updateTag({ name: 'robots', content: 'index, follow' });
        }
    }
}
